"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var DialogContentTheme = function DialogContentTheme(colors, breakpoints) {
  return {
    styleOverrides: {
      root: (0, _defineProperty2["default"])({
        padding: '0 20px 20px 20px'
      }, breakpoints.up('sm'), {
        padding: '0 32px 28px 32px'
      }),
      dividers: (0, _defineProperty2["default"])({
        borderBottom: 'none',
        borderColor: colors.grey10,
        padding: '20px 20px'
      }, breakpoints.up('sm'), {
        padding: '28px 32px'
      })
    }
  };
};

var _default = DialogContentTheme;
exports["default"] = _default;